import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation } from "swiper/modules";

import { WaveBottomBackground, WaveUpperBackground } from "~/components/posties/wave-background";
import type { newsFromScmpEducationQuery$key } from "~/queries/__generated__/newsFromScmpEducationQuery.graphql";

import FishAndCoral from "./fish-and-coral.png";
import {
  Container,
  GridContainer,
  Header,
  StyledArrowNext,
  StyledArrowPrevious,
  StyledImage,
  StyledImageContainer,
  StyledPostiesNewsFromScmpEducationItem,
  StyledSwiper,
  StyledSwiperSlide,
  SwiperContainer,
  SwiperWrapper,
  WaveMiddleBackground,
  WaveMiddleContainer,
  WaveUpperBackgroundContainer,
  WaveUpperLine,
  WaveUpperLineContainer,
} from "./styles";

export type Props = {
  id: string;
  reference: newsFromScmpEducationQuery$key;
};

export const PostiesNewsFromScmpEducation: FunctionComponent<Props> = ({
  id,
  reference: reference_,
}) => {
  const appConfig = useFragment(
    graphql`
      fragment newsFromScmpEducationQuery on Query {
        appConfig(filter: { entityId: "posties" }) {
          json
        }
      }
    `,
    reference_,
  );

  const postiesConfig = appConfig?.appConfig?.json as PostiesConfig;
  const items = postiesConfig?.brochureHomepage?.newsFromScmpEducation ?? [];

  if (items.length === 0) return null;

  return (
    <Container id={id}>
      <WaveUpperBackgroundContainer>
        <WaveUpperBackground $fillColor="#B2E8FF" />
        <WaveUpperLineContainer>
          <WaveUpperLine>
            <StyledImageContainer>
              <StyledImage alt={FishAndCoral.alt} src={FishAndCoral.src} />
            </StyledImageContainer>
          </WaveUpperLine>
        </WaveUpperLineContainer>
      </WaveUpperBackgroundContainer>
      <WaveMiddleContainer>
        <GridContainer>
          <Header>News from SCMP Learn</Header>
          <SwiperContainer>
            <SwiperWrapper>
              <StyledSwiper
                breakpoints={{
                  0: {
                    spaceBetween: 32,
                  },
                  1024: {
                    spaceBetween: 56,
                  },
                }}
                modules={[Navigation]}
                navigation={{
                  disabledClass: "swiper-button-disabled",
                  nextEl: ".image-swiper-button-next",
                  prevEl: ".image-swiper-button-prev",
                }}
                pagination={false}
                slidesPerView="auto"
              >
                <div className="swiper-button image-swiper-button-prev">
                  <StyledArrowPrevious />
                </div>
                <div className="swiper-button image-swiper-button-next">
                  <StyledArrowNext />
                </div>
                {items.map((item, index) => (
                  <StyledSwiperSlide key={index}>
                    <StyledPostiesNewsFromScmpEducationItem {...item} key={index} />
                  </StyledSwiperSlide>
                ))}
              </StyledSwiper>
            </SwiperWrapper>
          </SwiperContainer>
        </GridContainer>
        <WaveMiddleBackground />
      </WaveMiddleContainer>
      <WaveBottomBackground $fillColor="#B2E8FF" />
    </Container>
  );
};
PostiesNewsFromScmpEducation.displayName = "PostiesNewsFromScmpEducation";
